import React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import { stylingHelpers } from '../../designTokens';
import HeatStreakText from './HeatStreakText';

const { flexCenter } = stylingHelpers;

const baseStyles = ({ theme }) => css`
  border-radius: ${theme.borderRadius.circle};
  overflow: hidden;
  padding: 2px;
  position: relative;

  ${flexCenter()};

  &:before {
    content: '';
    border-radius: ${theme.borderRadius.circle};
    background-color: ${theme.colors.white};
    width: 100%;
    height: 100%;
  }

  svg {
    width: 0.7em;
  }
`;

const sizeStyles = ({ size }) => {
  const sizeMap = {
    bit: {
      width: '32px',
      height: '32px',
    },
    byte: {},
    kilo: {
      width: '67px',
      height: '67px',
    },
    mega: {},
  };

  const sizeProps = sizeMap[size] || sizeMap.bit;

  return css`
    ${sizeProps};
  `;
};

const variantStyles = ({ theme, variant }) => css`
  background-color: ${(variant && theme.colors.heatStreak[variant].start) || theme.colors.n700};
  color: ${(variant && theme.colors.heatStreak[variant].start) || theme.colors.n700};
`;

const gradientStyles = ({ theme, variant, isGradient }) =>
  isGradient &&
  css`
    background: linear-gradient(
      360deg,
      ${theme.colors.heatStreak[variant].start} 2%,
      ${theme.colors.heatStreak[variant].end} 47%
    );
    color: ${theme.colors.heatStreak[variant].start};
  `;

const Container = styled('div')(baseStyles, sizeStyles, variantStyles, gradientStyles);

const wrapperBaseStyles = () => css`
  ${flexCenter()};
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  text-align: center;

  img {
    max-width: 16px;
    max-height: 14px;
  }
`;

const Wrapper = styled('div')(wrapperBaseStyles);

const HeatStreakIcon = ({ ...props }) => (
  <Container {...props} variant={props.variant !== 'locked' && props.variant !== 'image' && props.variant}>
    <Wrapper>
      <HeatStreakText {...props} />
    </Wrapper>
  </Container>
);

export default HeatStreakIcon;
